import React from "react";

import { RenderWithDelay } from "../../../../components/LoadingIndicator/RenderWithDelay";
import { LoadingMessage } from "../../../components";

export const LoadingPlaceholder: React.FC = () => {
  return (
    <RenderWithDelay delay={10000} placeholder={<LoadingMessage />}>
      <LoadingMessage text="This is taking longer than expected." />
    </RenderWithDelay>
  );
};
